module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/mainBg_0e87804cb0572a7fab71ae0c8bbfdeed.jpg";